import { ACCOUNT_FEATURE, selectUserRolePermissions } from '@socialive/common';
import { useFeature } from '@socialive/features';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectIsDownloadsEnabled } from '~/store';

export default function useDisableVideoDownload() {
  const [, { enabled }] = useFeature(ACCOUNT_FEATURE.USER_ROLES);
  const isDownloadsEnabled = useSelector(selectIsDownloadsEnabled);
  const { canDownloadVideo } = useSelector(selectUserRolePermissions);

  const tooltip = useMemo(() => {
    if (enabled && !canDownloadVideo) return 'No permission to download';
    if (!isDownloadsEnabled) return 'Downloads disabled by administrator';
    return 'Download';
  }, [isDownloadsEnabled, canDownloadVideo, enabled]);

  const disableRightClickFunc = useCallback(
    (event) => {
      if (!isDownloadsEnabled) event?.preventDefault();
    },
    [isDownloadsEnabled]
  );

  return {
    disableRightClickFunc,
    tooltip,
    isDownloadsEnabled: enabled ? isDownloadsEnabled && canDownloadVideo : isDownloadsEnabled,
  };
}
